import {createMuiTheme, makeStyles} from '@material-ui/core/styles';
import {colores, estilosTextosPrincipales, tipografia} from '../../../AppStyle';
export const customStyles = makeStyles({
    borderNoticia: {
        backgroundColor: 'rgba(0, 0, 0, 0)',
        borderBottom: '0px solid rgba(0, 0, 0, 0)',
        marginBottom: -1,
        minHeight: 56,
        '&$expanded': {
          minHeight: 56,
        },
      },
    contenidoNoticia: {
        '&$collapse': {
          margin: '12px 0',
        },
      },
      textoTitular: {
        ...estilosTextosPrincipales.encabezadoH2,
        color: colores.escalaGrises.cien,
        maxWidth: '80%',
        marginTop: '2%',
        marginBottom: '7px'
    },
    fecha: {
        color: colores.escalaGrises.setenta,
        fontFamily: tipografia.regular,
        fontSize: '14px',
        marginBottom: '2%'
    },
    textoEntrada: {
        color: colores.escalaGrises.ochenta,
        fontFamily: tipografia.regular,
        maxWidth: '90%',
        marginBottom: '7px'
    },
    typography: {
        color: colores.principales.principal,
        fontFamily: tipografia.regular,
        fontSize: '16px',
        fontWeight: '700',
        fontStyle: 'normal',
        lineHeight: '16px',
    },
    classTextoEstatico: {
        ...estilosTextosPrincipales.body1,
        textAlign: 'justify'
    },
    claseIcon:{
        color: "green"
    }
});

export const overrideStyle = createMuiTheme({
    overrides: {
        MuiPaper: {
            elevation1: {
                boxShadow: '0px 0px 0px 0px rgb(0 0 0), 0px 0px 0px 0px rgb(0 0 0), 0px 0px 0px 0px rgb(0 0 0)',
            }
        },
        MuiAccordion: {
            root:{
                borderLeft: '200px',
                position: 'none'
            },
        },
        MuiAccordionSummary:{
            root: {
                minHeight: '55px',
                marginLeft: '-15px',
                marginTop: '-5px'
            }
        },
        MuiAccordionDetails:{
            root: {
                display: 'flex',
                padding: '8px 16px 16px',
                marginLeft: '-14px'
            }
        },
        MuiTypography:{
            body1:{
                width: '100%',
                wordWrap: 'break-word',
                overflowWrap: 'break-word',
                ...estilosTextosPrincipales.body1,
                fontSize: '14px',
                lineHeight: '20px'
            }
        }
    }
});